module.exports = __webpack_public_path__ + "static/mary-kay-1-0604f672e6e660079772ae0b602760cc.jpg";